<template>
  <div>
    <div class="container lnb d_container">
      <div class="contents_wrap">
        <div class="contents list-container">
          <div class="title">회원상세정보</div>
          <div class="list-content content tab-content">
            <div
              class="intro_tab col_5"
              @click="changeTab('basic')"
              :class="{ active: tab === 'basic' }"
            >
              기본정보
            </div>
            <div
              class="intro_tab col_5"
              @click="changeTab('payment')"
              :class="{ active: tab === 'payment' }"
            >
              결제내역
            </div>
            <div
              class="intro_tab col_5"
              @click="changeTab('premium')"
              :class="{ active: tab === 'premium' }"
            >
              프리미엄
            </div>
            <div
              class="intro_tab col_5"
              @click="changeTab('online')"
              :class="{ active: tab === 'online' }"
            >
              Korean Practice
            </div>
            <div
              class="intro_tab col_5"
              @click="changeTab('koin')"
              :class="{ active: tab === 'koin' }"
            >
              KOIN
            </div>
            <!-- <div
              class="intro_tab col_6"
              @click="changeTab('history')"
              :class="{ active: tab === 'history' }"
            >
              KOIN사용내역
            </div> -->
          </div>
          <div v-if="tab === 'basic'" class="list-content">
            <member-write-component
              :memberType="'studentDetail'"
              :memberKey="memberKey"
            ></member-write-component>
            <div class="pa15 text-center btn_wrap">
              <el-button type="save" @click="save">저장</el-button>
              <el-button type="cancel" @click="$router.back()">목록</el-button>
              <el-button class="float_right" type="cancel" @click="quit"
                >강제탈퇴</el-button
              >
            </div>
          </div>
          <payment-list-component
            class="list-content"
            :paymentType="'memberPayment'"
            :memberKey="memberKey"
            v-else-if="tab === 'payment'"
          ></payment-list-component>
          <member-check-premium-component
            class="list-content"
            v-else-if="tab === 'premium'"
            :memberKey="memberKey"
          ></member-check-premium-component>
          <online-member-firebase-component
            class="list-content"
            v-else-if="tab === 'online'"
            :memberKey="memberKey"
          ></online-member-firebase-component>
          <!-- <payment-list-component
            :paymentType="'koin'"
            class="list-content"
          ></payment-list-component> -->
          <!--                    <koin-component class="list-content" v-else-if="tab === 'koin'" :memberKey="memberKey"></koin-component>-->
          <koin-component v-else-if="tab === 'koin'"
          :memberKey="memberKey"
          :paymentType="'koinPayment'">
          </koin-component>
          <payment-list-component
            class="list-content"
            :paymentType="'koinUserHistory'"
            :memberKey="memberKey"
            v-if="tab === 'koin'"
          ></payment-list-component>
        </div>

        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
      </div>
    </div>
    <offline-review-modal :memberKey="memberKey"></offline-review-modal>
    <koin-create-modal></koin-create-modal>
    <koin-delete-modal></koin-delete-modal>
    <password-update-modal></password-update-modal>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import MemberWriteComponent from "@/components/member/MemberWriteComponent";
import OfflineReviewModal from "@/components/modal/OfflineReviewModal";
import PaymentListComponent from "@/components/payment/PaymentListComponent";
import MemberCheckPremiumComponent from "@/components/member/MemberCheckPremiumComponent";
import KoinComponent from "@/components/payment/KoinComponent";
import KoinCreateModal from "@/components/modal/KoinCreateModal";
import KoinDeleteModal from "@/components/modal/KoinDeleteModal";
import PasswordUpdateModal from "../../components/modal/PasswordUpdateModal";
import OnlineMemberFirebaseComponent from "@/components/online/OnlineMemberFirebaseComponent";
import util from "@/mixins/util";

export default {
  name: "MemberDetail",
  mixins: [],
  components: {
    PasswordUpdateModal,
    KoinDeleteModal,
    KoinCreateModal,
    KoinComponent,
    OnlineMemberFirebaseComponent,
    MemberCheckPremiumComponent,
    PaymentListComponent,
    OfflineReviewModal,
    MemberWriteComponent,
  },
  provide() {
    return {};
  },
  props: {},
  data() {
    return {
      memberKey: Number(this.$route.params.m_idx),
      tab: "basic",
    };
  },
  created() {
    if (!util.isEmpty(this.$route.query.tab)) {
      this.tab = this.$route.query.tab;
    }
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    save() {
      EventBus.$emit("writeMember");
    },
    changeTab(tab) {
      this.$router.replace(`${this.$route.path}`);
      this.tab = "";
      this.$nextTick(() => {
        this.tab = tab;
        this.$router.replace(`${this.$route.path}?tab=${tab}`);
      });
    },
    quit() {
      EventBus.$emit("runMemberQuit");
    },
  },
  watch: {
    "$route.path": {
      deep: true,
      handler: function (val, oldVal) {
        if (
          !util.isEmpty(this.$route.query.tab) &&
          this.tab != this.$route.query.tab
        ) {
          this.changeTab(this.$route.query.tab);
        }
        if (this.memberKey != this.$route.params.m_idx) {
          this.memberKey = Number(this.$route.params.m_idx);
        }
      },
    },
  },
};
</script>

<style scoped></style>
